/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import ModelSelectorWrapper from "components/model-selector/model-selector-wrapper";
import { useSelectFieldSchema } from "cms/fields/dynamic-field";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
import { useAuth } from "cms/auth/hooks/use-auth";
import { useCallback, useContext, useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import debounce from "lodash.debounce";

const ModelRefFieldEdit = () => {
    const { token } = useAuth();
    // const throttler = useThrottle()
    
    const ctx = useContext(ListItemContext);
    const { name, index, value, settings, updateListItem, disabled = false } = ctx;

    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { options: schemaOptions } = schemaSettings || {};
    const { filter, filterValue } = schemaOptions || {};
    
    const [model, setModel] = useState();
    const [itemLocalState, setItemLocalState] = useState({ value, settings });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 1200),
        [updateListItem]
    );
    const onModelChange = (model) => {
        const { guid = "" } = model || {};
        setModel(model?.guid);
        const updatedState = {
            ...itemLocalState,
            value: {
                model: guid,
                index
            },
        };
        setItemLocalState(updatedState);
        update(updatedState,index);
    };
    const onModelRemove = () => {
        setModel(undefined);
        const updatedState = {
            ...itemLocalState,
            value: {
                model: "",
                index
            }
        };
        setItemLocalState(updatedState);
        update(updatedState,index);
    };

    useEffect(() => {
        async function fetchData () {
            const model_guid = itemLocalState?.value?.model ? itemLocalState?.value?.model : itemLocalState?.value;
            if (model_guid) {
                const model = await SimpliCityAdminSDK.model.findOne(token, model_guid);
                if (model && model.guid) {
                    setModel(model);
                }
            }
        }
        const guid = itemLocalState?.value?.model ? itemLocalState?.value?.model : itemLocalState?.value;
        if (guid) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemLocalState.value]);

    return (
        <div className='simplicity-composer-field-primary-layout'>
            {/*<div className='simplicity-composer-field-primary'>*/}
            {/*  Edit Model Value  */}
            <ModelSelectorWrapper
                filter={filter}
                filterValue={filterValue}
                model={model}
                onModelChange={onModelChange}
                onModelRemove={onModelRemove}
                disabled={disabled}
            />
            {/*</div>*/}
        </div>
    );
};
export default ModelRefFieldEdit;
